export default function serialize(obj: any): any {
    const params: URLSearchParams = new URLSearchParams();
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const element = obj[key];
            params.set(key, element);
        }
    }
    return params;
}
